import { defineComponent as p, openBlock as s, createBlock as a, unref as e, mergeProps as l, withCtx as r, createVNode as n } from "vue";
import u from "./ghl-ui.es192.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es35.js";
import i from "./ghl-ui.es72.js";
import f from "./ghl-ui.es69.js";
p({
  name: "UIActionDropdown"
});
const w = p({
  __name: "ActionDropdown",
  props: {
    ...i.props,
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["select"],
  setup(t, { emit: c }) {
    const d = c;
    function m(o) {
      d("select", o);
    }
    return (o, g) => (s(), a(e(i), l({
      options: o.options,
      onSelect: m,
      id: `${t.id}-action-dropdown`
    }, o.$props), {
      default: r(() => [
        n(e(f), {
          quaternary: "",
          circle: "",
          iconOnly: "",
          id: `${t.id}-action-dropdown-trigger`
        }, {
          default: r(() => [
            n(e(u), { class: "w-5 h-5" })
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 16, ["options", "id"]));
  }
}), A = w;
export {
  A as default
};
